import { CouponInfo, DataResponse } from '../models';
import { ceV2Axios } from './axios';

export const getCouponByCode = async (code: string): Promise<CouponInfo | null> => (
  await ceV2Axios.get<DataResponse<CouponInfo | null>>(`/coupons/${encodeURIComponent(code)}`, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data;
